import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { LANDING_PAGE } from "constants/localstorage";
const MAX_PAGES = 5;
const getStoredPages = ()=>{
    const stored = localStorage.getItem(LANDING_PAGE);
    if (!stored) {
        return [];
    }
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
};
const LandingPageTracker = ()=>{
    useEffect(()=>{
        try {
            const currentPage = window.location.pathname;
            const pages = getStoredPages();
            const lastPage = pages[pages.length - 1];
            // Only add if different from the last page (avoid duplicates on refresh)
            if ((lastPage === null || lastPage === void 0 ? void 0 : lastPage.value) === currentPage) {
                return;
            }
            pages.push({
                value: currentPage,
                timestamp: Date.now()
            });
            // Keep only the last 5 pages
            const pagesToStore = pages.length > MAX_PAGES ? pages.slice(-MAX_PAGES) : pages;
            localStorage.setItem(LANDING_PAGE, JSON.stringify(pagesToStore));
        } catch (e) {
            Sentry.captureException(e);
        }
    }, []);
    return null;
};
export default LandingPageTracker;
